import type { CommentDto } from '@plugins/faq-lib/types';
import { Subscription } from '@plugins/shared/types';
import { CreateReply, UpdateReply } from '@plugins/shared/types/post/response';

export class CommentsLoaded {
  static readonly type = '[Comment] Comments loaded';
  constructor(public loadedComments: CommentDto[]) {}
}

export class MoreCommentsLoaded {
  static readonly type = '[Comment] More comments loaded';
  constructor(public loadedComments: CommentDto[]) {}
}

export class CreateComment {
  static readonly type = '[Comment] Create new comment';
  constructor(public comment: CreateReply) {}
}

export class UpdateComment {
  static readonly type = '[Comment] Update comment';
  constructor(public comment: UpdateReply) {}
}

export class DeleteComment {
  static readonly type = '[Comment] Delete comment';
  constructor(public commentId: string) {}
}

export class LikeComment {
  static readonly type = '[Comment] Like comment';
  constructor(public commentId: string) {}
}

export class SubscribedToAnswer {
  static readonly type = '[Comment] Subscribed to answer';
  constructor(public subscription: Subscription) {}
}
